import React, { Component } from "react";
import { externalAPI, callFMScript } from "fm-webviewer-bridge";
/**
 * adds two props to the children
 * exposeMethods - a function that exposes methods to the onhash based based api
 * callFMscript - a function that can call a FM script
 */
class WebViewerAPI extends Component {
  componentWillMount() {
    this.api = externalAPI();
    this.api.start();
  }

  componentWillUnmount() {
    this.api.stop();
  }

  render() {
    const { children } = this.props;
    var childrenWithProps = React.Children.map(children, child =>
      React.cloneElement(child, {
        exposeMethods: this.api.addMethods,
        callFMScript: callFMScript
      })
    );

    return <div>{childrenWithProps}</div>;
  }
}

export default WebViewerAPI;



// WEBPACK FOOTER //
// ./src/components/WebViewerApi/index.js